function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Alert from './Alert';
import classNames from 'classnames';
import { ALERT__24 } from '@homeaway/svg-defs';

function AlertDanger(props) {
  var buttonClasses = classNames('Alert--danger', props.className);
  return /*#__PURE__*/React.createElement(Alert, _extends({}, props, {
    className: buttonClasses,
    flairClassName: "bg--color-negative",
    svgClassName: "text-danger"
  }));
}

AlertDanger.propTypes = _extends({}, Alert.propTypes);
AlertDanger.defaultProps = _extends({}, Alert.defaultProps, {
  ariaLive: 'assertive',
  svgMarkup: ALERT__24
});
export default AlertDanger;
//# sourceMappingURL=AlertDanger.js.map